import InitVueApp from '@/entry';
import { appElement } from '../config';
import App from './App';
import store from '../store';
import '@/plugins/vee-validate';

new InitVueApp(App, appElement, { store });
